export default __webpack_public_path__ + "images/c28d94a6fa0f34bfc4009558c5236407-dating_tablet_1_1067x312.webp";